import { Box } from '@hover/blueprint';
import type { MotionValue, PanInfo } from 'framer-motion';
import { motion } from 'framer-motion';
import React, { useMemo } from 'react';

const MotionBox = motion(Box);

interface CarouselElementProps {
  index: number;
  renderPage: (props: { index: number }) => JSX.Element | null;
  x: MotionValue;
  onDragEnd(event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo): void;
  draggable?: boolean;
}

const CarouselElement = ({
  index,
  renderPage,
  x,
  onDragEnd,
  draggable = true,
}: CarouselElementProps) => {
  const child = useMemo(() => renderPage({ index }), [index, renderPage]);

  return (
    <MotionBox
      cursor="pointer"
      drag={draggable ? 'x' : false}
      dragElastic={1}
      draggable={draggable}
      height="100%"
      onDragEnd={onDragEnd}
      position="absolute"
      style={{
        x,
        left: `${index * 100}%`,
        right: `${index * 100}%`,
      }}
      width="100%"
    >
      {child}
    </MotionBox>
  );
};

export { CarouselElement };
